"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */

var ClayDatePickerDaysTable = function ClayDatePickerDaysTable(_ref) {
  var children = _ref.children,
    weeks = _ref.weeks;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, weeks.map(function (days, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "date-picker-date-row date-picker-row",
      "data-index": index,
      key: index,
      role: "row"
    }, days.map(function (day, index) {
      return _react.default.Children.only(children({
        day: day,
        key: index
      }));
    }));
  }));
};
var _default = exports.default = ClayDatePickerDaysTable;